module.exports = __webpack_public_path__ + "img/21.01e3721c.png";